/** InsCoder 2026-09-17 B + HP 26 tabs product cards: one swiper per tab panel + tabs + buy button loading **/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hp26-tpc]';
  var PANEL_SELECTOR = '[data-hp26-tabpanel]';
  var SLIDER_SELECTOR = '[data-hp26-swiper]';
  var MOBILE_BREAKPOINT = 990;
  var MOBILE_SPACE = 12;
  var DESKTOP_SPACE = 16;
  var MAX_SLIDES = 3;

  function initSection(root) {
    if (!root || root.dataset.hp26TpcReady === 'true') return;

    var panels = Array.prototype.slice.call(root.querySelectorAll(PANEL_SELECTOR));
    if (!panels.length) return;
    root.dataset.hp26TpcReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hp26-tab]'));
    var swipers = [];

    function initSwiper(sliderEl) {
      if (!window.Swiper || !sliderEl.querySelector('.swiper-slide')) return null;

      /** InsCoder 2026-09-17 B + Desktop tracks from Liquid: 1 or 2 cards -> 2 (50% each), 3 cards -> 3 (1/3 each) **/
      var slidesPerView = Number(sliderEl.dataset.hp26Slides) || 1;
      if (slidesPerView > MAX_SLIDES) slidesPerView = MAX_SLIDES;
      var isSingleCard = Boolean(sliderEl.closest('.hp_26_tpc__panel--single-card'));
      return new window.Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          0: {
            slidesPerView: isSingleCard ? 1 : 1.2,
            spaceBetween: isSingleCard ? 0 : MOBILE_SPACE
          },
          990: {
            slidesPerView: isSingleCard ? 1 : slidesPerView,
            spaceBetween: isSingleCard ? 0 : DESKTOP_SPACE
          }
        }
      });
    }

    // Swiper instances are kept in panel order, so index === data-hp26-tab value
    panels.forEach(function (panel) {
      var sliderEl = panel.querySelector(SLIDER_SELECTOR);
      swipers.push(sliderEl ? initSwiper(sliderEl) : null);
    });

    function setActiveTab(index) {
      tabs.forEach(function (tab) {
        var isActive = Number(tab.dataset.hp26Tab) === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var isActive = Number(panel.dataset.hp26Tabpanel) === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      // Panels start hidden, so Swiper measures 0 width until the panel is shown again
      if (swipers[index]) swipers[index].update();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(Number(tab.dataset.hp26Tab) || 0);
      });

      tab.addEventListener('keydown', function (event) {
        var direction = 0;
        if (event.key === 'ArrowRight') direction = 1;
        if (event.key === 'ArrowLeft') direction = -1;
        if (!direction || tabs.length < 2) return;

        event.preventDefault();
        var current = tabs.indexOf(tab);
        var target = tabs[(current + direction + tabs.length) % tabs.length];
        target.focus();
        target.click();
      });
    });

    /** InsCoder 2026-09-17 B + Buy button loading state only (add to cart / checkout is handled by the global .checkoutButton flow in theme.js) **/
    function setLoading(button) {
      if (button.classList.contains('is-loading')) return;
      if (button.getAttribute('aria-disabled') === 'true') return;
      button.classList.add('is-loading');
    }

    function clearLoading() {
      root.querySelectorAll('[data-hp26-atc].is-loading').forEach(function (button) {
        button.classList.remove('is-loading');
      });
    }

    root.querySelectorAll('[data-hp26-atc]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        setLoading(button);
      });
    });

    // Clear the stuck loading state when the page is restored from bfcache (browser back)
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) clearLoading();
    });
    /** InsCoder 2026-09-17 E + Buy button loading state only (add to cart / checkout is handled by the global .checkoutButton flow in theme.js) **/

    /** InsCoder 2026-09-21 B + Tab to open on page load, resolved in Liquid from the section setting. Sections that do not output the attribute fall back to the first tab. **/
    setActiveTab(Number(root.dataset.hp26InitialTab) || 0);
    /** InsCoder 2026-09-21 E + Tab to open on page load, resolved in Liquid from the section setting **/
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;

    var root = target.matches && target.matches(ROOT_SELECTOR)
      ? target
      : target.querySelector(ROOT_SELECTOR);

    if (root) initSection(root);
    else initAll();
  });
})();
/** InsCoder 2026-09-17 E + HP 26 tabs product cards: one swiper per tab panel + tabs + buy button loading **/
